import { postRequest } from '@/core';
import { subOrders } from '@/requests';

export default async function getSubOrdersRequest(filter) {
	let url = subOrders.getSearchPath();
	let response = await postRequest(url, {}, filter);
	return response;
}
